import "@fontsource/dm-sans"
import "@fontsource/dm-sans/500.css"
import "@fontsource/dm-sans/700.css"
import "@fontsource/dm-mono"
import "@fontsource/dm-mono/500.css"
import "@fontsource/space-mono/700.css"
import contextCursor from "./contextCursor/index.js"

export const onRouteUpdate = () => {
    contextCursor({}, true);
    contextCursor({
        radius: 25,
    });
}